import React from 'react'
import { isVideo } from '../utils/customerDisplayInformation.utils'

function CustomerDisplayPreview({ fileUrl, mediaType }) {
  if (!fileUrl) return null

  return (
    <div
      className="customer-display-file-preview"
      data-testid="container-file-preview">
      <label className="customer-display-label">Preview</label>

      <div className="customer-display-preview-box">
        {isVideo(mediaType) ? (
          <video
            src={fileUrl}
            controls
            className="customer-display-preview-media"
          />
        ) : (
          <img
            src={fileUrl}
            alt=""
            className="customer-display-preview-media"
          />
        )}
      </div>
    </div>
  )
}

export default CustomerDisplayPreview
